// extracted by mini-css-extract-plugin
module.exports = {"iconBrand":"AiSparkle_iconBrand__g2BVB","iconInherit":"AiSparkle_iconInherit__m0zgY"};